import { getDocs, orderBy, query, setDoc } from "firebase/firestore";

import { FirestoreRefs } from "igfd-commons/src/firebase/refs";

import type { MenuFavorite } from "@dashboard/types";

export interface MenuFavoriteApi {
  // Returns all menu favorites for the given user.
  fetchMenuFavorites(
    userId: string,
    restaurantUuid: string
  ): Promise<MenuFavorite[]>;

  // Updates an existing menu favorite.
  updateMenuFavorite(
    userId: string,
    restaurantUuid: string,
    menuFavorite: MenuFavorite
  ): Promise<void>;
}

/**
 * An implementation of the MenuFavoriteApi that uses Firestore as the backend.
 */
export class FirestoreBackedMenuFavoriteApi implements MenuFavoriteApi {
  private readonly firestoreRefs: FirestoreRefs;

  constructor(firestoreRefs: FirestoreRefs) {
    this.firestoreRefs = firestoreRefs;
  }

  public fetchMenuFavorites(
    userId: string,
    restaurantUuid: string
  ): Promise<MenuFavorite[]> {
    return getDocs(
      query(
        this.firestoreRefs.managerRestaurantMenuFavorites(
          userId,
          restaurantUuid
        )
      )
    ).then((querySnapshot) =>
      querySnapshot.docs.map((doc) => doc.data() as MenuFavorite)
    );
  }

  updateMenuFavorite(
    userId: string,
    restaurantUuid: string,
    menuFavorite: MenuFavorite
  ): Promise<void> {
    return setDoc(
      this.firestoreRefs.menuFavorite(
        userId,
        restaurantUuid,
        menuFavorite.menuId
      ),
      menuFavorite,
      {
        merge: true,
      }
    );
  }
}
